import { css } from '@emotion/core';
import { styled, minimumWidth } from '@feast-it/ui/light';

export const Container = styled.div(
  ({ theme }) => css`
    display: grid;
    gap: ${theme.spacing[10]};
    grid-template-columns: repeat(1, minmax(0, 1fr));

    ${minimumWidth(theme.breakpoints.medium)} {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    ${minimumWidth(theme.breakpoints.large)} {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    > * {
      min-width: 0;
    }
  `
);
